import React, { useState } from 'react';

// Navigation Component for Terms Page - Matching Main Page
const TermsNavigation = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <nav className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 sm:h-20 items-center">
          <div className="flex-shrink-0 flex items-center">
            <a href="/">
              <img 
                src="/main-logo.png" 
                alt="Banner Day Threads" 
                className="h-12 sm:h-16 opacity-90 hover:opacity-100 transition duration-300 drop-shadow-lg" 
              />
            </a>
          </div>
          <div className="hidden md:block">
            <div className="ml-10 flex items-center space-x-6 lg:space-x-8">
              <a href="/" className="text-black hover:text-gray-700 px-2 lg:px-3 py-2 font-medium drop-shadow-lg text-sm lg:text-base">Home</a>
              <a href="/styles" className="text-black hover:text-gray-700 px-2 lg:px-3 py-2 font-medium drop-shadow-lg text-sm lg:text-base">Our Styles</a>
              <a href="/about" className="text-black hover:text-gray-700 px-2 lg:px-3 py-2 font-medium drop-shadow-lg text-sm lg:text-base">About</a>
              <a href="/#contact" className="text-black hover:text-gray-700 px-2 lg:px-3 py-2 font-medium drop-shadow-lg text-sm lg:text-base">Contact Us</a>
              <a href="/#contact" className="bg-blue-600 text-white px-4 lg:px-6 py-2 rounded-full font-medium hover:bg-blue-700 transition duration-300 shadow-lg text-sm lg:text-base">Get Started</a>
            </div>
          </div>
          <div className="md:hidden flex items-center space-x-3">
            <a 
              href="/#contact" 
              className="bg-blue-600 text-white px-4 py-2 rounded-full font-medium hover:bg-blue-700 transition duration-300 shadow-lg text-sm"
            >
              Get Started
            </a>
            <button 
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} 
              className="text-black hover:text-gray-700 focus:outline-none drop-shadow-lg"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>
        {isMobileMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white bg-opacity-95 rounded-lg backdrop-blur-sm shadow-lg">
              <a href="/" className="block text-black hover:text-gray-700 px-3 py-3 font-medium text-base">Home</a>
              <a href="/styles" className="block text-black hover:text-gray-700 px-3 py-3 font-medium text-base">Our Styles</a>
              <a href="/about" className="block text-black hover:text-gray-700 px-3 py-3 font-medium text-base">About</a>
              <a href="/#contact" className="block text-black hover:text-gray-700 px-3 py-3 font-medium text-base">Contact Us</a>
              <a href="/#contact" className="block bg-blue-600 text-white px-6 py-3 rounded-full font-medium hover:bg-blue-700 transition duration-300 text-center mx-3 mt-2">Get Started</a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

// Footer Section - Matching Main Page
const Footer = () => (
  <footer className="bg-gray-900 text-white pt-12 sm:pt-16 pb-6 sm:pb-8">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12">
        <div className="sm:col-span-2 lg:col-span-1">
          <h3 className="text-xl sm:text-2xl font-bold bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent mb-4 sm:mb-6">
            Banner Day Threads
          </h3>
          <p className="text-gray-400 text-sm sm:text-base leading-relaxed">
            We craft premium custom headwear that fully highlights your brand. Not ours.
          </p>
        </div>
        <div>
          <h4 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">Products</h4>
          <ul className="space-y-1 sm:space-y-2">
            {['Snapbacks', 'Rope Hats', 'Trucker Hats', 'Bucket Hats', 'Visors'].map((item, index) => (
              <li key={index}>
                <span className="text-gray-400 text-sm sm:text-base">{item}</span>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">Company</h4>
          <ul className="space-y-1 sm:space-y-2">
            <li>
              <a href="/about" className="text-gray-400 hover:text-white transition-colors duration-300 text-sm sm:text-base">
                About
              </a>
            </li>
            <li>
              <a href="/#contact" className="text-gray-400 hover:text-white transition-colors duration-300 text-sm sm:text-base">
                Contact Us
              </a>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">Legal</h4>
          <ul className="space-y-1 sm:space-y-2">
            <li>
              <a href="/terms" className="text-gray-400 hover:text-white transition-colors duration-300 text-sm sm:text-base">
                Terms of Service
              </a>
            </li>
            <li>
              <a href="/privacy" className="text-gray-400 hover:text-white transition-colors duration-300 text-sm sm:text-base">
                Privacy Policy
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-gray-800 mt-8 sm:mt-12 pt-6 sm:pt-8 flex flex-col md:flex-row justify-between items-center">
        <p className="text-gray-400 mb-4 md:mb-0 text-sm sm:text-base text-center md:text-left">
        © 2025 Banner Day Threads, LLC. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
);

// Terms of Service Page Component
const TermsPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <TermsNavigation />
      
      {/* Content Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          
          {/* Header */}
          <div className="mb-12">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Terms of Service
            </h1>
          </div>
          
          {/* Work in Progress Message */}
          <div className="bg-blue-50 rounded-2xl p-12 mb-12">
            <div className="text-6xl mb-6">🚧</div>
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Work in Progress
            </h2>
            <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
              Our legal team is currently working on finalizing our Terms of Service. 
              Please check back soon for the complete terms and conditions.
            </p>
            <a 
              href="/#contact" 
              className="inline-flex items-center px-6 py-3 bg-blue-600 text-white rounded-full font-medium hover:bg-blue-700 transition duration-300"
            >
              Contact Us for Questions
              <svg className="ml-2 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </a>
          </div>

        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TermsPage;